export const getPickListStatusLabel = ({
	inventoryPicked,
	inventoryPartiallyPicked,
	isAnyItemPicked,
	pendingLabel = 'Pending',
}) => {
	if (inventoryPicked) {
		return 'Picked';
	}

	if (isAnyItemPicked) {
		return 'Part picked';
	}

	if (inventoryPartiallyPicked) {
		return 'Finished for now';
	}

	return pendingLabel;
};
